import SEOHead from "@/components/feature/SEOHead";
import HeroSection from "@/pages/home/components/HeroSection";
import CategoryNav from "@/pages/home/components/CategoryNav";
import HotRecommend from "@/pages/home/components/HotRecommend";
import LatestUpdate from "@/pages/home/components/LatestUpdate";
import FeaturesSection from "@/pages/home/components/FeaturesSection";

export default function Home() {
  return (
    <>
      <SEOHead
        title="免费韩漫-韩漫大全-韩国漫画下拉式在线阅读"
        description="韩漫之家汇集免费韩漫大全，支持韩国漫画下拉式在线阅读，您可轻松翻阅大量作品，从经典到新作一应俱全，满足您对韩漫的所有期待与热爱。"
        keywords="免费韩漫, 韩漫大全, 韩国漫画下拉式, 韩漫之家, 韩漫在线阅读"
        canonicalUrl="/"
        ogImage="https://readdy.ai/api/search-image?query=A%20beautiful%20collection%20of%20Korean%20manhwa%20comic%20covers%20arranged%20in%20a%20collage%2C%20warm%20and%20inviting%20atmosphere%2C%20creative%20layout%2C%20professional%20design&width=1200&height=630&seq=home-og&orientation=landscape"
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "韩漫之家",
            url: "https://www.hanmanzhijia.com",
            description: "韩漫之家汇集免费韩漫大全，支持韩国漫画下拉式在线阅读，您可轻松翻阅大量作品，从经典到新作一应俱全。",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://www.hanmanzhijia.com/search?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "韩漫之家",
            url: "https://www.hanmanzhijia.com",
            description: "免费韩漫在线阅读平台，提供海量韩国漫画资源",
            contactPoint: {
              "@type": "ContactPoint",
              email: "contact@hanmanzhijia.com",
              contactType: "customer service",
              availableLanguage: ["Chinese"],
            },
          }),
        }}
      />

      <HeroSection />
      <CategoryNav />
      <HotRecommend />
      <LatestUpdate />
      <FeaturesSection />
    </>
  );
}